<template>
	<div class="row voffset1">
		<div class="col-ms-12">
				<h2>{{ stepDisplay }}</h2>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			currentStep: function()	{
				return this.$store.state.user.currentStep;
			},
			auditTour1: function()	{
				return "FIRST_STEP" == this.currentStep;
			},
			auditCritique: function()	{
				return "CRITIC_STEP" == this.currentStep;
			},
			auditTour2: function()	{
				return "SECOND_STEP" == this.currentStep;
			},
			auditSatisfaction: function()	{
				return "SATISFACTION_SURVEY" == this.currentStep;
			},
			stepDisplay: function() {
				switch(this.currentStep) {
			    case "FIRST_STEP":
			        return "Audit tour 1";
			        break;
			    case "CRITIC_STEP":
			        return "Audit critique";
			        break;
					case "SECOND_STEP":
			        return "Audit tour 2";
			        break;
					case "SATISFACTION_SURVEY":
							return "Enquête satisfaction";
							break;
					default:
							return "Résultats";
				}
			},
		},
		methods: {
			changeStep: function(newStep)	{
				this.$store.dispatch('changeStep', newStep);
			},
			stepDisabled: function(step)	{
				return !this.$store.state.user.userAnswers[step].length;
			}
		}
	};
</script>
